import { render, staticRenderFns } from "./EocTabs.vue?vue&type=template&id=c46074b4&"
import script from "./EocTabs.vue?vue&type=script&lang=js&"
export * from "./EocTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports